import { createContext, useContext } from 'react';

import { SetUserType, YbugApi, YbugSettings } from '../../types/ybug.types';

type YbugContextType = {
  Ybug: YbugApi | null;
  init: (settings: Partial<YbugSettings>) => void;
};

type YbugProviderProps = {
  children: React.ReactNode;
  settings?: YbugSettings;
};

export const YbugContext = createContext<YbugContextType | null>(null);

export const useYbug = () => useContext(YbugContext);

export type { SetUserType, YbugApi, YbugContextType, YbugProviderProps, YbugSettings };
